<template>
  <Drawer
    :id="drawerId"
    title="Add External Job Record"
  >
    <v-card flat>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-text-field
            v-model="baseCost"
            label="Base Cost"
            :rules="[$rules.required]"
            outlined
          />
          <v-text-field
            v-model="shippingCost"
            label="Shipping Cost"
            outlined
          />
          <v-text-field
            v-model="salesTax"
            label="Sales Tax"
            outlined
          />
          <template v-if="!isPromo">
            <v-text-field
              v-model="postageCost"
              label="Postage Cost"
              outlined
            />
            <v-text-field
              v-model="turnaroundCost"
              label="Turnaround Cost"
              outlined
            />
          </template>
          <v-text-field
            v-model="externalOrderId"
            label="External Order Id"
            :rules="[$rules.required]"
            outlined
          />
          <v-text-field
            v-model="externalJobId"
            label="External Job Id"
            :rules="[$rules.required]"
            outlined
          />
        </v-form>
      </v-card-text>
    </v-card>
    <template #append>
      <div class="px-3 py-5">
        <v-btn
          color="primary"
          block
          large
          :loading="saving"
          @click="save"
        >
          Add
        </v-btn>
      </div>
    </template>
  </Drawer>
</template>

<script>
import Drawer from '@/components/layout/Drawer';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import enums from '../../../helpers/enums';
export default {
  name: 'PrintJobAddExternalJob',
  components: { Drawer },
  data() {
    return {
      valid: false,
      saving: false,
      job: {},
      isPromo: false,
      baseCost: 0,
      shippingCost: 0,
      salesTax: 0,
      postageCost: 0,
      turnaroundCost: 0,
      externalJobId: null,
      externalOrderId: null,
      drawerId: enums.DRAWERS.PRINT_JOB_ADD_EXTERNAL_JOB
    };
  },
  computed: {
    drawerOpenedAt() {
      return this.$store.state.drawers.lastOpenedAt;
    },
    ...mapGetters({
      initialData: 'drawers/data'
    })
  },
  watch: {
    drawerOpenedAt() {
      if (this.drawerId === this.$store.getters['drawers/topDrawer']?.id) {
        const data = this.initialData(this.drawerId);
        this.job = cloneDeep(data.job);
        this.isPromo = data.isPromo === true;
        this.baseCost = 0;
        this.shippingCost = 0;
        this.salesTax = 0;
        this.postageCost = 0;
        this.turnaroundCost = 0;
        this.externalJobId = null;
        this.externalOrderId = null;
      }
    }
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('orders/addExternalJob', {
          orderId: this.job.orderId,
          jobId: this.job.jobId,
          baseCost: this.baseCost,
          shippingCost: this.shippingCost,
          salesTax: this.salesTax,
          postageCost: this.postageCost,
          turnaroundCost: this.turnaroundCost,
          externalJobId: this.externalJobId,
          externalOrderId: this.externalOrderId,
          isPromo: this.isPromo
        })
        .then(() => {
          this.$store.commit('drawers/GO_BACK');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
